/**
 * API Integration feature types
 */

export interface ThirdPartyFormData {
  description: string;
  email: string;
  firstName: string;
  lastName: string;
  phoneNumber: string;
  companyName: string;
}

export interface ApiCredentials {
  key?: string;
  secret?: string;
  tokenExpiry?: string;
}

export interface ExistingCredential {
  id: string;
  key: string;
  description: string;
  createdDate: string;
  lastUsedDate?: string;
  active: boolean;
  // Contact info for editing
  email?: string;
  firstName?: string;
  lastName?: string;
  phoneNumber?: string;
  companyName?: string;
}

// Type for tracking which credential was copied
export type CopiedType = 'none' | 'key' | 'secret' | 'both';

// Type for token actions
export type TokenAction = 'edit' | 'revoke';

// Grouped snackbar state
export interface SnackbarState {
  open: boolean;
  message: string;
  severity?: 'success' | 'error' | 'warning' | 'info';
}

// Confirmation dialog state
export interface ConfirmationDialogState {
  open: boolean;
  title: string;
  message: string;
  confirmLabel: string;
  confirmColor?: 'primary' | 'error' | 'warning';
  onConfirm: () => void;
}

// Initial form state
export const INITIAL_FORM_DATA: ThirdPartyFormData = {
  description: '',
  email: '',
  firstName: '',
  lastName: '',
  phoneNumber: '',
  companyName: '',
};

// Helper to convert ExistingCredential to form data for editing
export const credentialToFormData = (credential: ExistingCredential): ThirdPartyFormData => ({
  description: credential.description || '',
  email: credential.email || '',
  firstName: credential.firstName || '',
  lastName: credential.lastName || '',
  phoneNumber: credential.phoneNumber || '',
  companyName: credential.companyName || '',
});

// --- Event Log Types ---

export interface EventLogEntry {
  traceId: string;
  timestamp: string;
  operationId: string;
  method: string;
  path: string;
  responseStatus: number;
  durationMs: number;
  clientIp: string;
  thirdPartyId: string;
  accountId: string;
  queryString?: string;
  requestBody?: string;
  responseBody?: string;
}

export interface EventLogFilters {
  thirdPartyId: string;
  operationId: string;
  startDate: string;
  endDate: string;
  size: number;
}
